import { BaseApiService, type ApiPaths } from './base';

// Extract types from generated API paths for user endpoints
type ProfileResponse =
  ApiPaths['/users/me']['get']['responses'][200]['content']['application/json'];
type UpdateProfileResponse =
  ApiPaths['/users/me-update']['put']['responses'][200]['content']['application/json'];

export type UserProfileResponse = ProfileResponse['data'];
export type UserUpdateProfileRequest =
  NonNullable<ApiPaths['/users/me-update']['put']['requestBody']> extends {
    content: { 'application/json': infer T };
  }
    ? T
    : Record<string, any>;
export type UserUpdateProfileResponse = UpdateProfileResponse['data'];

class UsersApiService extends BaseApiService {
  /**
   * Get current user profile
   * Returns authenticated user's profile information
   */
  async getMe(): Promise<UserProfileResponse> {
    return this.makeRequest<UserProfileResponse>('/users/me', {
      method: 'GET',
    });
  }

  /**
   * Update current user profile
   * Updates authenticated user's profile information
   */
  async updateMe(
    updates: UserUpdateProfileRequest
  ): Promise<UserUpdateProfileResponse> {
    return this.makeRequest<UserUpdateProfileResponse>('/users/me-update', {
      method: 'PUT',
      body: updates,
    });
  }
}

export const usersApi = new UsersApiService();
